import { Input, Button, Select, Form, Row, Col, Space, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { createAIPrompt, updateAIPrompt } from '../../api/ai';

const AIPromptEditModalView = ({ categories, defaultPrompt, onClose, onUpdate, open }) => {
    const [loading, setLoading] = useState(false);
    const [currCategory, setCurrCategory] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        setCurrCategory(defaultPrompt?.promptCategory)
    }, [defaultPrompt])

    useEffect(() => {
        if(currCategory === 'TickersGenerationQuestion' || currCategory === 'TickersSuggestedQuestion') {
            form.setFieldValue('description', '');
        }
    }, [currCategory])

    useEffect(() => {
        if (defaultPrompt) {
            form.setFieldValue('promptCategory', defaultPrompt.promptCategory);
            form.setFieldValue('description', defaultPrompt.description);
            form.setFieldValue('systemPrompt', defaultPrompt.systemPrompt);
        } else {
            resetFields();
        }
    }, [open]);

    const resetFields = () => {
        form.setFieldValue('promptCategory', null);
        form.setFieldValue('description', '');
        form.setFieldValue('systemPrompt', '');
    }

    const onSubmit = () => {
        let params = {
            promptCategory: form.getFieldValue('promptCategory'),
            description: form.getFieldValue('description'),
            systemPrompt: form.getFieldValue('systemPrompt')
        };
        setLoading(true);
        if (defaultPrompt?.id) {
            updateAIPrompt({ ...params, id: defaultPrompt.id }).then(res => {
                if (res) {
                    resetFields();

                    onClose();
                    onUpdate();
                }
            }).finally(() => {
                setLoading(false);
            })
        } else {
            createAIPrompt(params).then(res => {
                if (res) {
                    resetFields();

                    onClose();
                    onUpdate();
                }
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    const drawTitle = () => {
        if (defaultPrompt) {
            return 'Edit AI Prompt'
        }
        return 'Create AI Prompt'
    }

    return (
        <div>
            <Modal
                title={drawTitle()}
                width={480}
                mask
                onCancel={onClose}
                open={open}
                styles={{
                    body: {
                        paddingTop: 32,
                    },
                }}
                footer={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={loading}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    layout="vertical"
                    form={form}
                    requiredMark={false} >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item name='promptCategory' label='Prompt Category'>
                                <Select placeholder='select promot category' options={categories} onChange={(value) => setCurrCategory(value)} />
                            </Form.Item>
                        </Col>
                    </Row>

                    {
                        currCategory && (
                            <>
                                {
                                    (currCategory !== 'TickersGenerationQuestion' && currCategory !== 'TickersSuggestedQuestion') && (
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <Form.Item name='description' label='User Prompt'>
                                                    <Input.TextArea placeholder='description' rows={5} />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    )
                                }

                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item name='systemPrompt' label='System Prompt'>
                                            <Input.TextArea placeholder='systemPrompt' rows={5} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                </Form>
            </Modal>
        </div>
    )
}

export default AIPromptEditModalView;